module.exports = __webpack_public_path__ + "static/media/trend-down.c9116e6c.svg";